import { Title, useTranslate } from 'react-admin';
import { FileUpload } from '@components/FileUpload';
import { dataObject } from '@src/object.type';
import { entityResource as ent } from '@src/entityResource';

const headers = [
    'alasan_gagal',
    'data_kode_barang',
    'data_nama_barang',
    'data_harga_beli',
    'data_harga_jual',
    'data_stok',
    'data_barang_jasa',
    'data_show_toko',
    'minimum_stok',
    'diskon',
    'berat_dan_satuan',
    'berat',
    'letak_rak',
    'keterangan',
    'kategori',
    'gambar',
];

export const ScheduleUpload = () => {
    const translate = useTranslate();
    const verifyData = (data: dataObject[]) => {
        const normalizedData = data
            .filter((row: dataObject) => {
                // Check if at least one field has a value
                return (
                    row.data_kode_barang ||
                    row.data_nama_barang ||
                    row.data_harga_beli ||
                    row.data_harga_jual ||
                    row.data_stok ||
                    row.kategori
                );
            })
            .map((row: dataObject) => {
                return {
                    ...row,
                    data_kode_barang: row.data_kode_barang
                        .replace(/\s/g, '')
                        .replace(/"/g, ''),
                };
            });

        return normalizedData.map((d: dataObject) => {
            const {
                data_kode_barang,
                data_nama_barang,
                data_harga_beli,
                data_harga_jual,
                data_stok,
                kategori,
            } = d;
            return {
                ...(data_kode_barang && { code: data_kode_barang }),
                ...(data_nama_barang && { name: data_nama_barang }),
                ...(data_harga_beli && { purchaseSchedule: data_harga_beli }),
                ...(data_harga_jual && { sellingSchedule: data_harga_jual }),
                ...(data_stok && { stock: data_stok }),
                ...(kategori && { category: kategori }),
            };
        });
    };

    return (
        <>
            <Title title={translate('resources.schedule.action.upload')} />
            <FileUpload
                headers={headers}
                fileInputLabel={translate('resources.schedule.action.upload')}
                api={ent.SCHEDULE.UPLOAD_API}
                resource={ent.SCHEDULE.NAME}
                verifyData={verifyData}
            />
        </>
    );
};
